(function($){
  $(".-a-stagger-slideup").each(function(){
    var waypoint = new Waypoint({
      element: $(this),
      offset: '66%',
      handler: function(direction) {
        // this.disable();
        if(direction == "down"){
          this.animation.play();
        } else {
          this.animation.reverse();
        }
        // console.log(direction);

      }
    });

    var target = $(this).find(".-a-target");
    $(this).show();
    waypoint.animation = new TimelineLite({paused:true});
    waypoint.animation.staggerFrom(target, 0.5, {y:50, opacity:0}, 0.2);
  });
  $(".-a-stagger-slideright").each(function(){
    var waypoint = new Waypoint({
      element: $(this),
      offset: '66%',
      handler: function(direction) {
        // this.disable();
        if(direction == "down"){
          this.animation.play();
        } else {
          this.animation.reverse();
        }
      }
    });

    var target = $(this).find(".-a-target");
    $(this).show();
    waypoint.animation = new TimelineLite({paused:true});
    waypoint.animation.staggerFrom(target, 0.5, {x:50, opacity:0}, 0.2);
  });
  $(".-a-classtoggle").each(function(){
    var waypoint = new Waypoint({
      element: $(this),
      offset: '66%',
      handler: function(direction) {
        // this.disable();
        if(direction == "down"){
          this.element.attr("class", "-is-active");
        } else {
          this.element.attr("class", "");
        }
      }
    });
  });
  $(".-a-pause-stagger-slideup").each(function(){

    var target = $(this).find(".-a-target"),
        animation = new TimelineLite({paused:true});

    $(this).show();

    animation.staggerFrom(target, 0.5, {y:50, opacity:0}, 0.2);

    setTimeout(function(){
      animation.play();
    },2000);
  });

  $(".-a-pause-stagger-slideright").each(function(){

    var target = $(this).find(".-a-target"),
        animation = new TimelineLite({paused:true});

    $(this).show();

    animation.staggerFrom(target, 0.5, {x:50, opacity:0}, 0.2);

    setTimeout(function(){
      animation.play();
    },2000);
  });

  $(".-a-parallax-container").each(function(){
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

    var tween = TweenMax.to($(this).find(".-a-parallax-grow"), 2, {"padding-top": "15%"}, 0.15);
    var tween2 = TweenMax.from($(this).find(".-a-parallax-shrink"), 2, {"padding-top": "0"}, 0.15);
    var tween3 = TweenMax.fromTo($(this).find(".-a-parallax-target-mid"), 2, {y: "20%"}, {y: "-100%", ease:Power0.easeNone}, 0.15);

    new ScrollMagic.Scene({triggerElement: $(this)})
      .setTween(tween)
			.addTo(controller);

    new ScrollMagic.Scene({triggerElement: $(this)})
      .setTween(tween2)
			.addTo(controller);

    new ScrollMagic.Scene({triggerElement: $(this)})
      .setTween(tween3)
			.addTo(controller)
      .on("progress", function(event){
        Waypoint.refreshAll();
      });
  });
})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/modules/animations.js
 ** module id = 6
 ** module chunks = 1
 **/